import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

export default function TabComp({ tabContext, bgColor, paddingTop }) {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => { setValue(newValue); };
    return (
        <Box>
            <Tabs value={value} onChange={handleChange} sx={{ '.MuiTabs-list': { justifyContent: {md: 'center', xs: 'unset'}, overflowX: 'auto' }, '.MuiTabs-indicator': { display: 'none' }, backgroundColor: bgColor ?? 'unset', paddingTop: paddingTop ?? '77px' }}>
                {tabContext.tabs.map((tabLabel, index) => (
                    <Tab 
                    disableFocusRipple
                    disableTouchRipple
                        key={index} 
                        label={tabLabel} 
                        sx={{ 
                            '&.Mui-selected': { color: '#1E353D' }, 
                            fontSize: '1.125rem',
                            fontWeight: 'bold', 
                            color: '#c0c7c9', 
                            borderRight: index !== tabContext.tabs.length - 1 ? '0.125rem solid #eaeae9' : 'none' 
                        }} 
                    />
                ))}
            </Tabs>
            {tabContext.context[value]}
        </Box>
    );
}